import { usePrices } from "@/contexts/prices-provider";
import { AdminTeamUserDTO } from "@shaarp/common";
import { useEffect } from "react";
import { DataTable } from "../data-table/data-table";
import { dataTableAdminTeamUsersColumns } from "./data-table-admin-team-users-columns";

export default function DataTableAdminTeamUsers({
  users,
  isLoading = false,
}: {
  users: AdminTeamUserDTO[];
  isLoading?: boolean;
}) {
  const { apiFetchPrices } = usePrices();

  useEffect(() => {
    apiFetchPrices();
  }, []);

  return (
    <DataTable
      data={users}
      columns={dataTableAdminTeamUsersColumns()}
      isLoading={isLoading}
    />
  );
}
